import Picture from '../models/Picture';
import {cimaisePicture} from '../routes';

export default class LightboxState {
    opened: boolean = false
    pictureId: string | null = null
    backgroundRoutePath: string | null = null;

    open(picture: Picture): void {
        this.backgroundRoutePath = m.route.get();
        this.opened = true;
        this.pictureId = null; // Reset so it doesn't flash the old picture for a second
        document.body.classList.add('cimaise-lightbox-open');
        m.route.set(cimaisePicture(picture));
    }

    close(restoreUrl: boolean = true): void {
        this.opened = false;
        document.body.classList.remove('cimaise-lightbox-open');

        if (restoreUrl && this.backgroundRoutePath) {
            m.route.set(this.backgroundRoutePath);
        }
    }

    isOpen(): boolean {
        return this.opened;
    }

    openPage(id: string): void {
        this.pictureId = id;
        m.redraw();
    }
}
